module.exports = __webpack_public_path__ + "static/media/past.50f57426.jpg";